import React from "react";
import { useContext, useEffect, useState } from "react";
import "./style.css";
import TrackContext from "../../contexts/track-context";
import Playlist from "./Playlist";
import { BouncingLoader } from "../../pure-components/Loader";
import QueueMusicIcon from '@material-ui/icons/QueueMusic'

const NewInspiration = (props) => {

  const trackContext=useContext(TrackContext)

  return (
    <div 
      className="sm:flex sm:flex-col sm:w-full lg:mx-auto p-5 bg-bg rounded-2xl"
      style={{ backgroundColor: "rgb(var(--bg))", color: "rgb(var(--header))", minHeight: "80vh", maxHeight : "80vh", overflowY:"scroll" }}
    >
    {/* <div className="text-sm font-medium dark:text-gray-400 dark:border-gray-700">
      <ul className="flex flex-wrap -mb-px border-b pb-3">
        <li className="mr-2 text-left w-full sm:w-60 rounded-lg flex items-center">
          <QueueMusicIcon className="playlist-icon" />
          <span className="inline-block p-3 font-semibold text-lg sm:text-xl ml-2">
            Playlists
          </span>
        </li>
      </ul>
    </div>
    <div className="d-help mb-10 sm:mb-20 text-center sm:text-left">
      <div className="insp-head font-bold inspirationbox">
        <h2 className="text-xl sm:text-2xl md:text-3xl">
          LET MAMA BE YOUR INSPIRATION
        </h2>
      </div>
      <div className="inspirationbox">
        <p className="inspiration-main-content top-content-design text-sm sm:text-base lg:text-lg leading-relaxed">
          These carefully curated thematic playlists are designed to give you a feel of our massive and highly diverse catalog.
          They can be a source of inspiration for your creative ideas. Whenever you hear a track that you like, click on the
          <span className="font-bold"> magic wand </span>
          and Mama's <strong>AI-powered</strong> search engine, Maya, will suggest similar music.
        </p>
      </div>
    </div> */}
    <div className="w-full flex-wrap border-b pb-3 text-lg dark:text-gray-400 dark:border-gray-700">
          <QueueMusicIcon className="playlist-icon" />
          <span className="inline-block p-3 font-semibold text-lg sm:text-xl ml-2">
            New Release Highlights
          </span>
    </div>
    <div className="w-full">
      {trackContext.clearData ? "" : (!props.maiaOnWork && trackContext.loading) && <BouncingLoader />}
      <Playlist maiaOnWork={props.maiaOnWork} />
    </div>
  </div>
    

  );
};

export default NewInspiration;


